/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventTicketAdminParticipateRequest, EventTicketAdminRegisterRequest } from 'src/app/shared/models/admin/members.model';
import { Resource } from '../../../shared/models';
import { ObservableResult } from '../../../shared/store';
import {
  EventCardTime,
  EventCardTypeRequest,
  EventRecurrenceRequest,
  EventReminderRequest,
  EventSessionRequest,
  EventTickets,
  EventTicketsRequest,
} from '../../resource/store/admin/resource-event-admin.state.model';
import { EventCardsDataService } from './data.service';

@Injectable()
export class MockEventCardsDataService implements EventCardsDataService {
  setEventCardTypes(eventUid: string, request: EventCardTypeRequest): ObservableResult<EventCardTypeRequest> {
    return ObservableResult.ofSuccess();
  }

  setEventCardDates(eventUid: string, request: EventCardTime): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  setEventTickets(eventUid: string, request: EventTicketsRequest): ObservableResult<EventTickets> {
    return ObservableResult.ofSuccess();
  }

  deleteEventTickets(eventUid: string): ObservableResult<EventTickets> {
    return ObservableResult.ofSuccess();
  }

  setEventReminders(eventUid: string, request: EventReminderRequest): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  registerToEvent(eventUid: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  unregisterFromEvent(eventUid: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  attendToEvent(eventUid: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  attendToEventFromQrCode(eventUid: string, participationCode: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  adminRegisterToEventBulk(eventUid: string, request: EventTicketAdminRegisterRequest): ObservableResult<EventTickets> {
    return ObservableResult.ofSuccess();
  }

  adminUnregisterFromEventBulk(eventUid: string, usersUids: string[]): ObservableResult<EventTickets> {
    return ObservableResult.ofSuccess();
  }

  adminAttendToEventBulk(eventUid: string, request: EventTicketAdminParticipateRequest): ObservableResult<EventTickets> {
    return ObservableResult.ofSuccess();
  }

  adminMoveToWaitingListEventBulk(eventUid: string, usersUids: string[]): ObservableResult<EventTickets> {
    return ObservableResult.ofSuccess();
  }

  exportEventCalendarEvent(eventUid: string, languageCode?: string): Observable<string> {
    return Observable.create();
  }

  registerToSession(eventUid: string, sessionId: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  unregisterFromSession(eventUid: string, sessionId: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  createSession(eventUid: string, request: EventSessionRequest): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  updateSession(eventUid: string, sessionId: string, request: EventSessionRequest): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  deleteSession(eventUid: string, sessionId: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  cancelSession(eventUid: string, sessionId: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  setRecurrenceRule(eventUid: string, request: EventRecurrenceRequest): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }

  deleteRecurrenceRule(eventUid: string): ObservableResult<Resource> {
    return ObservableResult.ofSuccess();
  }
}
